<div class="row main-title-content" [ngStyle]="rowNgStyle">
  <div class="col-md-12 d-flex align-items-center justify-content-center">
    <p class="title-text">{{titulo}}</p>
  </div>
</div>

